import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchRooms } from '@/renderer/services/accommodationService';

export function useRooms(propertyId: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.accommodation.rooms(propertyId ?? ''),
    queryFn: () => fetchRooms(propertyId!),
    enabled: !!propertyId,
    staleTime: 1000 * 60 * 5,
  });
}
